const info = () => {
    return {
        errors: {},
        errors_info: {},
        warnings: {},
        warnings_info: {},
    }
}
const getDefaultState = () => {
    return {
        priceListFileId: null,
        show: false,
        params: {
            parseFromRow: 1,
            showFromRow: 1,
            showLimit: 300,
            calcAlias: true,
            mergeCellsRange: null,
            categoryType: 'column',
            aliases: {},
        },
        info: info(),
        rightTableLoaded: false
    }
}

export const StepTwo = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        resetState({ state, commit })  {
            commit('setDefault');
        },
        resetErrors({ state, commit })  {
            commit('setInfo', info());
        },
    },
    getters: {
        nameSelected: state =>  {
            return Object.values(state.params.aliases).find(value => value === 'name') !== undefined;
        },
        priceSelected: state =>  {
            return Object.values(state.params.aliases).find(value => value === 'price') !== undefined;
        },
        categorySelected: state =>  {
            if (state.params.categoryType === 'column'){
                return Object.values(state.params.aliases).find(value => value === 'category') !== undefined;
            }
            return state.params.mergeCellsRange !== null;
        },
        codeSelected: state =>  {
            return Object.values(state.params.aliases).find(value => value === 'code') !== undefined;
        },
        showRightTable:  (state, getters) => {
            return (state.params.categoryType === 'priceless' || state.params.categoryType === 'absent' || getters.categorySelected)
                && getters.priceSelected
                && getters.nameSelected;
        },
        stepThreeAvailable:  (state, getters) => {
            return getters.showRightTable && state.rightTableLoaded && Object.keys(state.info.errors).length === 0;
        }
    },
    mutations: {
        setDefault(state) {
            Object.assign(state, getDefaultState())
        },
        setVisible(state) {
            state.show = true;
        },
        setInfo(state, payload ) {
            _.set(state,'info', payload)
        },
        setCategoryType(state, payload) {
            _.set(state.params,'categoryType', payload)
        },
        setPriceListFileId(state, payload) {
            state.priceListFileId = payload;
        },
        setAliases(state, payload ) {
             _.set(state.params,'aliases', payload)
        },
        setCellsRange(state, payload ) {
             _.set(state.params,'mergeCellsRange', payload)
        },
        setParseFromRow(state, payload ) {
             _.set(state.params,'parseFromRow', payload)
        },
        setShowFromRow(state, payload ) {
             _.set(state.params,'showFromRow', payload)
        },
        setCalcAlias(state, payload ) {
             _.set(state.params,'calcAlias', payload)
        },
        setShowLimit(state, payload ) {
             _.set(state.params,'showLimit', payload)
        },
        setRTStatus(state, payload ) {
            state.rightTableLoaded = payload
        },
    }
};